export type FileAttachMeta = { name: string; dataUrl?: string };

export async function readMaybeDataUrl(file: File, maxBytes: number): Promise<FileAttachMeta> {
  if (file.size > maxBytes) {
    return { name: file.name };
  }
  return await new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () =>
      resolve({ name: file.name, dataUrl: typeof reader.result === 'string' ? reader.result : undefined });
    reader.readAsDataURL(file);
  });
}
